<template>
  <v-modal
      id="total-detail-modal"
      modal-title="Детали"
      hide-default-footer
  >
    <template #modal-content>
      <b-list-group>

        <b-list-group-item
            v-for="type in totalDetail"
            :key="type.name"
        >
         <div><b>{{type.name}}</b></div>
         <div>
           Юзеров: {{type.userAmount}}
         </div>
          <div>
            Последний запуск: {{type.lastActivityDate}}
          </div>
        </b-list-group-item>
      </b-list-group>
    </template>

    <template #modal-footer>
      <div class="d-flex justify-content-end mt-2">
        <b-button
            variant="outline-secondary"
            @click="close"
        >
          Закрыть
        </b-button>
      </div>
    </template>

  </v-modal>
</template>

<script>
import VModal from "@/common/VModal.vue";

export default {
  name: 'AppTotalDetailModal',
  components: {VModal},
  props: {
    totalDetail: {
      type: Object,
      required: true,
    },
  },
  methods: {
    open() {
      this.$bvModal.show('total-detail-modal')
    },
    close () {
      this.$bvModal.hide('total-detail-modal')
    }
  }

}
</script>
